import type { InventoryEquipment } from '@/modules/inventory/types/boat.types';

export interface EquipmentTotals {
  count: number;
  cost: number;
  price: number;
}

type PricedRow = Pick<InventoryEquipment, 'cost' | 'price'>;

/** Whole cents, or null for a blank or non-numeric amount ("915.00" → 91500). */
function toCents(value: number | string | null | undefined): number | null {
  if (value === null || value === undefined || value === '') return null;
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) ? Math.round(n * 100) : null;
}

/**
 * #1286 — the footer totals of an equipment list. Amounts arrive as the server's
 * decimal strings or as numbers the dealer typed; blank ones are left out.
 * Summed in cents so the total matches the invoice to the cent.
 */
export function equipmentTotals(rows: readonly PricedRow[]): EquipmentTotals {
  let cost = 0;
  let price = 0;
  for (const row of rows) {
    cost += toCents(row.cost) ?? 0;
    price += toCents(row.price) ?? 0;
  }
  return { count: rows.length, cost: cost / 100, price: price / 100 };
}
